import { TipoEvaluacion } from './tipo-evaluacion.model';
import { NodoEstructuraJerarquica} from './nodo-estructura-jerarquica.model';
import { Usuario } from './usuario.model';

export class EstructuraJerarquica {

    id: number;
    nombre: string;
    tipoEvaluacion: TipoEvaluacion[];
    descripcion: string;
    nodos: NodoEstructuraJerarquica[];
    habilitada: boolean;

    /**
     * Constructor
     *
     * @param estructura
     */
    constructor(estructura)
    {
        {
            this.id = estructura.id || null;
            this.nombre = estructura.nombre || '';
            this.tipoEvaluacion = estructura.tipoEvaluacion || [];
            this.descripcion = estructura.descripcion || '';
            this.nodos = estructura.nodos || [];
            this.habilitada = estructura.habilitada || false;

        }
    }
}

export function getUsuarios():Usuario[]{

  var usuarios = [];
  var usuariosId = [];
  this.nodos.forEach(element => {

    element.usuarios.getUsuarios().forEach(usuario => {

      if(usuariosId.indexOf(usuario.id)==-1){
        usuarios.push(usuario);
        usuariosId.push(usuario.id);
      }

    });


  });

  return usuarios;

}
